import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomieChatPage from "@/pages/HomieChatPage";

export const Route = createFileRoute("/homie/chat")({
  head: () => seoHead("/homie/chat"),
  component: HomieChatPage,
});
